import "./WhyChoose.css";
import factoryImage from "../../assets/images/gallery/gallery10.jpg";

import {
    FaAward,
    FaIndustry,
    FaBoxes,
    FaTruck
} from "react-icons/fa";

function WhyChoose() {

    const features = [

        {
            icon: <FaAward />,
            number: "01",
            title: "30+ Years Experience",
            text: "Experienced professionals delivering reliable industrial packaging solutions."
        },

        {
            icon: <FaIndustry />,
            number: "02",
            title: "Premium Manufacturing",
            text: "Advanced production processes ensuring consistent quality and precision."
        },

        {
            icon: <FaBoxes />,
            number: "03",
            title: "Custom Packaging",
            text: "Packaging solutions designed specifically for your products and industry."
        },

        {
            icon: <FaTruck />,
            number: "04",
            title: "Pan India Supply",
            text: "Reliable nationwide delivery with dependable service and support."
        }

    ];

    return (

        <section className="why-section">

            <div className="container-custom">

                <div className="section-heading">

                    <span>WHY TIGI INDUSTRIES</span>

                    <h2>Packaging Partner You Can Trust</h2>

                    <p>

                        Combining decades of expertise, advanced manufacturing,
                        and customer-focused solutions to deliver dependable
                        industrial packaging across India.

                    </p>

                </div>

                <div className="row align-items-center">

                    <div className="col-lg-6">

                        {

                            features.map((item,index)=>(

                                <div
                                    className="feature-card"
                                    key={index}
                                >

                                    <div className="feature-number">

                                        {item.number}

                                    </div>

                                    <div className="feature-icon">

                                        {item.icon}

                                    </div>

                                    <div>

                                        <h4>{item.title}</h4>

                                        <p>{item.text}</p>

                                    </div>

                                </div>

                            ))

                        }

                    </div>

                    <div className="col-lg-6">

                        <div className="why-image">

                            <img
                                src={factoryImage}
                                alt="Factory"
                            />

                            <div className="experience-box">

                                <h3>30+</h3>

                                <span>Years of Excellence</span>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </section>

    );

}

export default WhyChoose;